// src/services/bookService.js
import apiClient from '../api/apiClient'; // ✅ جایگزین api ناشناخته

export const fetchBooks = (params) => {
    return apiClient.get('books/', { params });
};

export const fetchBookBySlug = (slug) => {
    return apiClient.get(`books/${slug}/`);
};

export const fetchCategoryBySlug = (slug) => {
    return apiClient.get(`books/filters/categories/${slug}/`);
};

export const fetchBookCategories = () => {
    return apiClient.get('books/filters/categories/');
};

export const fetchBookTopics = () => {
    return apiClient.get('books/filters/topics/');
};

export const fetchBookPublishers = () => {
    return apiClient.get('books/filters/publishers/');
};

export const fetchBookAuthors = () => {
    return apiClient.get('books/filters/authors/');
};

const bookService = {
    fetchBooks,
    fetchBookBySlug,
    fetchCategoryBySlug,
    fetchBookCategories,
    fetchBookTopics,
    fetchBookPublishers,
    fetchBookAuthors,
};

export default bookService;